// removed by extract-text-webpack-plugin
module.exports = {"block":"restore__block-3trD2","title":"restore__title-ct_Sy","inputGroup":"restore__inputGroup-2SVWV","tooltipWrapper":"restore__tooltipWrapper-1C1qe","description":"restore__description-21Oly","submit":"restore__submit-1rWSh blocks__blue-tjpdI blocks__button-1iODk","button":"restore__button-3z5Ez blocks__button-1iODk","link":"restore__link-22kR2","redirect":"restore__redirect-1-JKH"};


//////////////////
// WEBPACK FOOTER
// ./components/auth/restore/restore.css
// module id = 794
// module chunks = 0